import classNames from 'classnames';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Accordion from 'components/Accordion';
import Chevron, { DIRECTIONS } from 'components/Chevron';
import { cn } from 'utils/Tailwind';

const Dropdown = ({
  content,
  dropdownHeader,
  isOpen,
  className,
  onClick,
  index,
  pdpStorytellingEnabled,
  ...otherProps
}) => {
  const classes = classNames('Dropdown', className);
  const accordionClasses = classNames('Dropdown__accordion');
  const ariaID = kebabCase(`dropdown-accordion-${dropdownHeader}-${index}`);

  return (
    <div className={classes} {...otherProps}>
      <button
        onClick={() => (isOpen ? onClick(null) : onClick(index, dropdownHeader))}
        className={cn(
          'Dropdown__header flex w-full cursor-pointer items-center justify-between border-none py-6 pl-0 pr-6 text-left outline-1',
          {
            'py-4 pl-0 pr-6 md:py-6': pdpStorytellingEnabled,
            'py-6 pl-0 pr-0': !pdpStorytellingEnabled,
          }
        )}
        aria-expanded={isOpen}
        aria-controls={ariaID}
      >
        <span
          className={cn('', {
            'text-[18px] font-bold md:text-1xl/none': pdpStorytellingEnabled,
            'text-xs/none font-bold uppercase tracking-widest': !pdpStorytellingEnabled,
          })}
        >
          {dropdownHeader}
        </span>
        <Chevron direction={isOpen ? DIRECTIONS.UP : DIRECTIONS.DOWN} />
      </button>

      <div className={accordionClasses} id={ariaID} role="region">
        <Accordion isOpen={isOpen}>
          <div
            className={cn(
              '[&>*:last-child]:!mb-0 [&>p]:max-w-3xl [&>ul>li>p]:!mb-0 [&>ul]:!mb-6 [&_p]:!text-sm [&_strong]:!text-sm',
              {
                'pb-6': isOpen,
              }
            )}
          >
            {content}
          </div>
        </Accordion>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  dropdownHeader: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number,
  pdpStorytellingEnabled: PropTypes.bool,
};

Dropdown.defaultProps = {
  isOpen: false,
  className: '',
  index: null,
};

export default Dropdown;
